module.exports = __webpack_public_path__ + "img/tg.b2246fda.svg";